export default __webpack_public_path__ + "static/media/IBimageKneeExtensionTerminalStance2.594c694b.png";